export default __webpack_public_path__ + "static/media/Gas Welding.948b0268.jpg";